var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import { EGamePhase, EGameStatus, } from "../../../types";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectMatchState, selectShowRoles, setMatchState, toggleShowRoles, } from "../../../store/match";
import { Delimiter } from "../../atoms/Delimiter";
import { VotesList } from "../VotesList";
import { ModalNew } from "../../atoms/Modal/Modal";
import { PlayerActions } from "../PlayerActions";
import * as api from "../../../api/matches";
import { confirmPlayerPass } from "../../../api";
import { ModalWrapperNew } from "../../atoms/ModalWrapper/ModalWrapper";
import { MatchEnd } from "../../../pages/MatchEnd";
import { useAlerts } from "../../molecules/Alerts";
import { getMafiaErrors } from "../../../utils";
import VotesIcon from "../../../../public/img/VotesIcon.svg";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { DeskFooterComponent } from "../DeskFooterComponent";
import { DeskHeaderComponent } from "../DeskHeaderComponent/DeskHeaderComponent";
const Container = styled.div `
  font-family: "FuturaPT", system-ui, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  background-color: #0d0d11;
  min-height: 100dvh;
  padding: 16px;
`;
const GameDesk = styled.div `
  position: relative;
  width: 838px;
  height: 100%;
  display: flex;
  //margin: 0 auto;
`;
const DeskWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  touch-action: none;
`;
const DeskHeader = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  width: calc(100% - 120px);
  z-index: 1000;
`;
const GameInfoContainer = styled.div `
  width: 100%;
`;
const ModalWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
  padding: 30px 30px 0;
  min-width: 527px;
`;
const ModalVotesWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
`;
const VotesButton = styled.div `
  display: flex;
  align-items: center;
`;
export function OldMatchDesk({ players, onClickPlayerAction, gameButtonState, setCurrentPlayerId, addOnComponent, }) {
    var _a, _b, _c;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const showRoles = useAppSelector(selectShowRoles);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [viewVotes, setViewVotes] = useState(false);
    const [viewFouls, setViewFouls] = useState(false);
    const [viewEndGame, setViewEndGame] = useState(false);
    const [isCancelLoading, setIsCancelLoading] = useState(false);
    const [isRequestSent, setIsRequestSent] = useState(false);
    const candidates = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).candidates || [], [matchState]);
    const shooters = useMemo(() => { var _a, _b; return ((_b = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.shootout) === null || _b === void 0 ? void 0 : _b.players) || []; }, [matchState]);
    const votes = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).votes || [], [matchState]);
    const gameStatus = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus, [matchState]);
    const { setAlerts } = useAlerts();
    const getPlayer = (playerId) => matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
    const onPlayerClickInner = (playerId) => __awaiter(this, void 0, void 0, function* () {
        if (playerId === (selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id)) {
            setSelectedPlayer(null);
        }
        if (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => (player === null || player === void 0 ? void 0 : player.id) === playerId)) {
            setSelectedPlayers(selectedPlayers.filter((player) => player.id !== playerId));
            yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(""));
            return;
        }
        setSelectedPlayer(getPlayer(playerId) || null);
        const player = getPlayer(playerId);
        if (player &&
            selectedPlayers &&
            gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([...selectedPlayers, player]);
        }
        else if (player &&
            selectedPlayers &&
            gameStatus !== EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([player]);
        }
        yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(playerId));
    });
    const onVotesOpen = () => {
        setViewVotes(true);
    };
    const onVotesClose = () => {
        setViewVotes(false);
    };
    const onFoulsClick = () => {
        setViewFouls(!viewFouls);
    };
    const onEndPageClick = () => {
        setViewEndGame(!viewEndGame);
    };
    const onChangeViewModeClick = () => {
        dispatch(toggleShowRoles());
    };
    const onChangeRole = () => {
        setSelectedPlayer(null);
        setSelectedPlayers([]);
    };
    const onPassButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        var _d, _e;
        const currentVoteId = ((_d = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _d === void 0 ? void 0 : _d.voteId) || "";
        const currentPlayer = (_e = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _e === void 0 ? void 0 : _e.find((p) => { var _a; return p.id === ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer); });
        if (currentPlayer === undefined) {
            return;
        }
        if (isRequestSent) {
            return;
        }
        try {
            setIsRequestSent(true);
            const result = yield confirmPlayerPass(currentVoteId, currentPlayer.id);
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
            setIsRequestSent(false);
        }
        catch (err) {
            errorHandler(err);
            console.error("MatchDesk onStartGameClick error", err.response);
            setIsRequestSent(false);
        }
    });
    const cancelLastAction = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id) || isCancelLoading)
            return;
        setIsCancelLoading(true);
        try {
            const result = yield api.cancelAction(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            dispatch(setMatchState(result));
            setIsCancelLoading(false);
        }
        catch (e) {
            setIsCancelLoading(false);
            console.log(getMafiaErrors(e));
            setAlerts(getMafiaErrors(e));
            // console.error('Match cancelAction', (e as any).response)
        }
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id))
            return;
        try {
            const result = yield api.getMatchState(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            // console.log('Match getMatchState', result)
            dispatch(setMatchState(result));
            // dividePlayers(result.players)
        }
        catch (e) {
            console.error("Match getMatchState", e.response);
        }
    });
    const getRoleName = useEffect(() => {
        var _a;
        setCurrentPlayerId(((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) || null);
    }, [matchState]);
    const isSuggested = (playerId) => candidates.find((c) => c.id === playerId);
    const roundStarter = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roundStarter) === playerId; };
    const isCurrentPlayer = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) === playerId; };
    const votesCount = (playerId) => {
        const result = votes.find((c) => c.playerId === playerId);
        return (result === null || result === void 0 ? void 0 : result.votes) || 0;
    };
    const votingProcess = gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
        gameStatus === EGameStatus.PLAYER_VOTING ||
        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE;
    return (_jsxs(Container, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [gameStatus === EGameStatus.GAME_ROLE_SET_ROLES_COUNT ? (_jsx(DeskHeaderComponent, { gameStatus: gameStatus, onFoulsClick: onFoulsClick, onPassButtonClick: onPassButtonClick, isRequestSent: isRequestSent, onChangeViewModeClick: onChangeViewModeClick, gameButtonState: gameButtonState, onVotesOpen: onVotesOpen, cancelLastAction: cancelLastAction, onEndPageClick: onEndPageClick, onThemesButtonClick: function () {
                    throw new Error("Function not implemented.");
                } })) : (_jsx(DeskFooterComponent, { gameStatus: gameStatus, onFoulsClick: onFoulsClick, onPassButtonClick: onPassButtonClick, isRequestSent: isRequestSent, onChangeViewModeClick: onChangeViewModeClick, gameButtonState: gameButtonState, onVotesOpen: onVotesOpen, cancelLastAction: cancelLastAction, onEndPageClick: onEndPageClick, onThemesButtonClick: function () {
                    throw new Error("Function not implemented.");
                } })), _jsx("div", { children: _jsxs(GameInfoContainer, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [(gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                            gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                            gameStatus === EGameStatus.PLAYER_VOTING ||
                            gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsxs(_Fragment, { children: [_jsxs(VotesButton, Object.assign({ onClick: onVotesOpen }, { children: [_jsx("img", { src: VotesIcon, alt: "VotesIcon" }), _jsx(Typography, Object.assign({ sx: {
                                                marginLeft: "10px",
                                                color: "#1976D2",
                                                fontWeight: "600",
                                            }, variant: "body1" }, { children: "\u0413\u043E\u043B\u043E\u0441\u0430" }))] })), _jsx(Delimiter, { top: "12px" })] })), addOnComponent === null || addOnComponent === void 0 ? void 0 : addOnComponent({
                            player: selectedPlayer,
                            onClose: onChangeRole,
                            onFouls: onFoulsClick,
                            players: selectedPlayers,
                        })] })) }), viewVotes && (_jsx(ModalNew, Object.assign({ close: true, onClose: onVotesClose }, { children: _jsx(ModalVotesWrapper, { children: _jsx(VotesList, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], votes: ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.votes) || [], previousVote: ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.previousVote) || null, voteItems: ((_c = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _c === void 0 ? void 0 : _c.voteItems) || [], dayNumber: (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1 }) }) }))), viewFouls && (_jsx(ModalNew, Object.assign({ close: true, onClose: onFoulsClick }, { children: _jsx(ModalWrapper, { children: _jsx(PlayerActions, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], matchId: (matchState === null || matchState === void 0 ? void 0 : matchState.id) || "", reload: () => getMatchState() }) }) }))), viewEndGame && (_jsx(ModalNew, Object.assign({ close: true, onClose: onEndPageClick }, { children: _jsx(MatchEnd, {}) })))] })));
}
